import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrestoComponent } from './simple-icons-presto.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrestoComponent ],
    exports:      [ SimpleIconsPrestoComponent ],
    bootstrap:    []
})
export class SimpleIconsPrestoModule {}
